module.exports = __webpack_public_path__ + "static/media/04-final.ed2ad783.webp";